import { ColorEnum } from '@/constants/color'
import BackArrowIcon from '@/features/ui/icons/components/BackArrowIcon'
import { FC } from 'react'
import { Pressable, StyleSheet } from 'react-native'

interface BackButtonProps {
    onPress: () => void
}

const BackButton: FC<BackButtonProps> = ({ onPress }) => {
    return (
        <Pressable onPress={onPress} style={styles.button}>
            <BackArrowIcon color={ColorEnum.GRAY_900} />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    button: {
        height: 24,
        width: 24,
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 24,
    },
})

export default BackButton
